// extracted by mini-css-extract-plugin
module.exports = {"Report-card-box":"bX","reportCardBox":"bX","report-img-wrap":"bY","reportImgWrap":"bY","report-title":"bZ","reportTitle":"bZ","report-date":"b0","reportDate":"b0"};